import { render, staticRenderFns } from "./Create-Warranty-Intenal.vue?vue&type=template&id=04f6f34d&scoped=true"
import script from "./Create-Warranty-Intenal.vue?vue&type=script&lang=js"
export * from "./Create-Warranty-Intenal.vue?vue&type=script&lang=js"
import style0 from "./Create-Warranty-Intenal.vue?vue&type=style&index=0&id=04f6f34d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6f34d",
  null
  
)

export default component.exports